import React from 'react';
import { motion } from 'framer-motion';
import { Mail, Phone, MapPin, Facebook, Twitter, Instagram, Linkedin, ArrowRight } from 'lucide-react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-dark-footer text-white pt-24 pb-12 overflow-hidden relative" data-id="element-112">
      {/* Decorative Background */}
      <div className="absolute top-0 right-0 w-1/2 h-1/2 bg-primary/5 rounded-full blur-[120px] -translate-y-1/2 translate-x-1/4" data-id="element-113" />
      <div className="absolute bottom-0 left-0 w-1/3 h-1/3 bg-secondary/5 rounded-full blur-[100px] translate-y-1/4 -translate-x-1/4" data-id="element-114" />

      <div className="container mx-auto px-6 relative z-10" data-id="element-115">
        <div className="grid lg:grid-cols-12 gap-16 mb-20" data-id="element-116">
          {/* Brand Column */}
          <div className="lg:col-span-4" data-id="element-117">
            <a href="/" className="inline-block mb-8" data-id="element-118">
              <div className="bg-white p-5 rounded-[24px] inline-block shadow-xl" data-id="element-119">
                <img src="https://www.harmonyhealthcaremd.com/wp-content/themes/harmonyhealthcarees376/images/main-logo.png" alt="Harmony Healthcare" className="h-10 w-auto object-contain" data-id="element-120" />
              </div>
            </a>
            <p className="text-gray-400 text-lg leading-relaxed mb-10 max-w-sm" data-id="element-121">
              Providing premium, compassionate home healthcare services across
              Maryland. Our mission is to enrich lives through excellence and
              dedication.
            </p>
            <div className="flex gap-4" data-id="element-122">
              {[Facebook, Twitter, Instagram, Linkedin].map((Icon, i) => <a key={i} href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-primary transition-colors duration-300" data-id="element-123">
                  <Icon className="w-5 h-5" data-id="element-124" />
                </a>)}
            </div>
          </div>

          {/* Quick Links */}
          <div className="lg:col-span-2" data-id="element-125">
            <h4 className="text-xl font-heading font-bold mb-8" data-id="element-126">Quick Links</h4>
            <ul className="space-y-4" data-id="element-127">
              {['Home', 'About Us', 'Our Services', 'Careers', 'Resources', 'Blog'].map(link => <li key={link} data-id="element-128">
                  <a href="#" className="text-gray-400 hover:text-primary transition-colors flex items-center gap-2 group" data-id="element-129">
                    <div className="w-1.5 h-1.5 rounded-full bg-primary opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-130" />
                    {link}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="lg:col-span-3" data-id="element-131">
            <h4 className="text-xl font-heading font-bold mb-8" data-id="element-132">Contact Us</h4>
            <ul className="space-y-6" data-id="element-133">
              <li className="flex gap-4" data-id="element-134">
                <div className="w-10 h-10 rounded-xl bg-white/5 flex items-center justify-center flex-shrink-0" data-id="element-135">
                  <Phone className="w-5 h-5 text-primary" data-id="element-136" />
                </div>
                <div data-id="element-137">
                  <div className="text-sm text-gray-400 mb-1" data-id="element-138">Call Us</div>
                  <a href="tel:240-468-4545" className="font-bold hover:text-primary transition-colors" data-id="element-139">
                    240-468-4545
                  </a>
                </div>
              </li>
              <li className="flex gap-4" data-id="element-140">
                <div className="w-10 h-10 rounded-xl bg-white/5 flex items-center justify-center flex-shrink-0" data-id="element-141">
                  <Mail className="w-5 h-5 text-primary" data-id="element-142" />
                </div>
                <div data-id="element-143">
                  <div className="text-sm text-gray-400 mb-1" data-id="element-144">Email Us</div>
                  <a href="mailto:info@harmonyhealthcaremd.com" className="font-bold hover:text-primary transition-colors" data-id="element-145">
                    info@harmonyhealthcaremd.com
                  </a>
                </div>
              </li>
              <li className="flex gap-4" data-id="element-146">
                <div className="w-10 h-10 rounded-xl bg-white/5 flex items-center justify-center flex-shrink-0" data-id="element-147">
                  <MapPin className="w-5 h-5 text-primary" data-id="element-148" />
                </div>
                <div data-id="element-149">
                  <div className="text-sm text-gray-400 mb-1" data-id="element-150">Our Location</div>
                  <address className="not-italic font-bold" data-id="element-151">
                    123 Main St, Suite 100
                    <br data-id="element-152" />
                    Maryland, USA
                  </address>
                </div>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div className="lg:col-span-3" data-id="element-153">
            <h4 className="text-xl font-heading font-bold mb-8" data-id="element-154">Newsletter</h4>
            <p className="text-gray-400 mb-6" data-id="element-155">
              Stay updated with our latest news and healthcare tips.
            </p>
            <form className="relative" data-id="element-156">
              <input type="email" placeholder="Email Address" className="w-full bg-white/5 border border-white/10 rounded-full py-4 px-6 focus:outline-none focus:border-primary transition-colors" data-id="element-157" />
              <button className="absolute right-2 top-2 bottom-2 px-6 bg-primary rounded-full hover:bg-primary-dark transition-colors" data-id="element-158">
                <ArrowRight className="w-5 h-5" data-id="element-159" />
              </button>
            </form>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-12 border-t border-white/10 flex flex-col md:row justify-between items-center gap-6" data-id="element-160">
          <p className="text-gray-500 text-sm" data-id="element-161">
            © {currentYear} Harmony Healthcare, INC. All rights reserved.
          </p>
          <div className="flex gap-8 text-sm text-gray-500" data-id="element-162">
            <a href="#" className="hover:text-white transition-colors" data-id="element-163">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-164">
              Terms of Service
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-165">
              Accessibility
            </a>
          </div>
        </div>
      </div>
    </footer>;
}